export default {
  /**
   * Obtener la ruta actual del state
   */
  getRoute: state => () => state.route,
  /**
   * Obtener el model + datos del paso 1
   */
  getConsulta: state => () => state.consulta,
  getPaso1: state => () => state.paso1,
  getConfirmacionData: state => () => {
    return {
      nombre: state.paso1.nombre,
      apellido: state.paso1.apellido,
      email: state.paso1.email,
      telefonoArea: state.paso1.celular.area,
      telefonoNumero: state.paso1.celular.numero,
      documentoTipo: state.paso1.documento.tipo,
      documentoNumero: state.paso1.documento.numero
    };
  }
};
